<template>
  <v-container>
    <edit-user-dialog
      v-model="userDialog"
      :user="selectedUser"
      v-on:validate-edit-user="editUser($event)"
      v-on:validate-create-user="createUser($event)"
    />
    <v-row>
      <v-col>
        <v-row justify="space-between">
          <v-col lg="4" sm="8">
            <h1 class="display-1 font-weight-light">
              {{ $t("Manage_Users.Users") }}
            </h1>
          </v-col>
          <v-col lg="2" align="right">
            <v-btn
              outlined
              color="green"
              v-on:click="
                selectedUser = undefined;
                userDialog = true;
              "
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t("Generic.Add") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              :label="$t('Generic.Search')"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :loading="usersLoading"
              :headers="headers"
              :items="users"
              :search="search"
              :items-per-page="rowsPerPage"
              :no-data-text="$t('Generic.No_Data')"
              :no-results-text="$t('Generic.No_Data_Search')"
              class="elevation-1"
              :footer-props="{
                itemsPerPageText: $t('Generic.Rows_per_page')
              }"
            >
              <template v-slot:item.Status="{ item }">
                <v-btn
                  x-small
                  outlined
                  :color="item.active ? 'green' : 'grey'"
                  v-on:click="changeActiveState(item)"
                  >{{
                    item.active
                      ? $t("Manage_Users.Active")
                      : $t("Manage_Users.Inactive")
                  }}</v-btn
                >
              </template>
              <template v-slot:item.Roles="{ item }">{{
                item.roles.length ? item.roles.join() : $t("Generic.NA")
              }}</template>
              <template v-slot:item.Actions="{ item }">
                <v-btn small text icon color="blue" class="ma-0 pa-0">
                  <v-icon
                    small
                    class="ma-0 pa-0"
                    v-on:click="
                      selectedUser = item;
                      userDialog = true;
                    "
                    >mdi-pencil</v-icon
                  >
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UserService from "@/services/UserService";
import AuthenticationService from "@/services/AuthenticationService";
import EditUserDialog from "@/components/ManageUsers/EditUserDialog";

export default {
  data() {
    return {
      search: "",
      usersLoading: true,
      selectedUser: undefined,
      userDialog: false,
      rowsPerPage: 10,
      users: [],
      headers: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$i18n.t("Generic.Mail"),
          align: "left",
          value: "mail"
        },
        {
          text: this.$i18n.t("Generic.Roles"),
          align: "left",
          value: "Roles",
          sortable: false
        },
        {
          text: this.$i18n.t("Generic.Status"),
          align: "left",
          value: "Status",
          width: "100",
          sortable: false
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "right",
          sortable: false
        }
      ]
    };
  },
  methods: {
    changeActiveState(user) {
      user.active = !user.active;
      UserService.UpdateUser(user)
        .then(response =>
          this.$emit("show-success", this.$i18n.t("Success.User_state_changed"))
        )
        .catch(error => {
          user.active = !user.active;
          this.$emit("show-error", this.$i18n.t("Error.User_state_changed"));
        });
    },
    editUser(editedUser) {
      UserService.UpdateUser(editedUser)
        .then(response => {
          this.userDialog = false;
          Object.assign(this.selectedUser, editedUser.user);
          this.$emit("show-success", this.$i18n.t("Success.User_edited"));
        })
        .catch(error =>
          this.$emit("show-error", this.$i18n.t("Error.User_Edition_Failed"))
        );
    },
    createUser(newUser) {
      AuthenticationService.CreateNewUser(newUser)
        .then(response => {
          this.userDialog = false;
          newUser.user.id = response.data;
          this.users.push(newUser.user);
          this.$emit("show-success", this.$i18n.t("Success.User_created"));
        })
        .catch(error =>
          this.$emit("show-error", this.$i18n.t("Error.User_Creation_Failed"))
        );
    }
  },
  components: {
    EditUserDialog
  },
  mounted() {
    UserService.GetAllUsers()
      .then(response => (this.users = response.data))
      .catch(error =>
        this.$emit("show-error", this.$i18n.t("Error.Users_Not_Retrieved"))
      )
      .finally(() => (this.usersLoading = false));
  }
};
</script>
